import FeatureEnabledDashboard from 'portal/src/layouts/base/FeatureEnabledDashboard';

import isSmartMeterViewEnabled from './isSmartMeterViewEnabled';

export default function SmartMeterView({
  slug,
  disabledSlug,
}: {
  slug: string;
  disabledSlug?: string;
}): React.ReactElement {
  return (
    <FeatureEnabledDashboard
      slug={slug}
      disabledSlug={disabledSlug}
      isFeatureEnabled={isSmartMeterViewEnabled}
    />
  );
}
